export default {
  // 页面标题
  title: '您的推广计划已部署完成，恭喜！',
  
  // 页面描述
  description: {
    prefix: '在接下来的',
    highlight: '24小时内',
    suffix: '，Aha 将为您匹配合适的达人。匹配完成后，您会收到合作确认提醒，以确保合作顺利进行。',
  },
  
  // 按钮
  buttons: {
    checkInstructions: '查看 Aha 指南',
    viewCampaign: '查看活动',
  },
  
  // 下一步说明标题
  nextStepsTitle: '接下来将会发生：',
  
  // 步骤说明
  steps: {
    step1: {
      title: 'Aha 向达人发送邀请',
      description: '我们会自动为您的品牌邀请合适的达人。24-48 小时内，您会开始收到达人申请并收到通知。您可以查看每个资料以及合作价格，并选择批准或拒绝。',
    },
    step2: {
      title: '达人创作内容',
      description: '达人内容草稿提交后，您会立即收到通知。请审核通过或提供修改建议以确保与品牌保持一致。',
    },
    step3: {
      title: '您将获得成果',
      description: '内容上线后，您可以查看数据报告，其中包含浏览量、点击量、互动率等关键指标，并可按活动或单个达人查看。',
    },
    stepApproval: {
      title: '您审核并批准内容',
      description: '当达人提交内容后，您会立即收到通知。请审核并选择批准，或提供反馈，确保符合您的品牌要求。',
    },
  },
};
